import { Observable, map } from 'rxjs';
import { environment } from '@utility/app.util';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
  IGenerateTextData,
  IGenerateTextPayload,
  IGenerateTextDataServer,
  IGenerateTextPayloadServer,
} from '@lib/generate-ai-text.interface';

@Injectable()
export class AiGenerateTextService {

  constructor(private http: HttpClient) { }

  public generateAIText(data: IGenerateTextPayload): Observable<IGenerateTextData> {
    const payload: IGenerateTextPayloadServer = {
      include_emojis: data.includeEmojis,
      include_hashtags: data.includeHashtags,
      custom_admin_context: data.customAdminContext,
    };
    return this.http.post<{data: IGenerateTextDataServer}>(`${environment.apiUrl}/v2/ai/messages/suggested-share-text`, payload)
      .pipe(
        map((response: {data: IGenerateTextDataServer}) => this.tranformGenerateAIText(response.data)),
      )
  }

  private tranformGenerateAIText(data: IGenerateTextDataServer): IGenerateTextData {
    return {
      content: data.content,
      originalMessageRequest: data.original_message_request,
    };
  }
}
